<template>
  <div>
    <card class="w-100">
      <el-form class="form-horizontal" :model="store" :rules="rules" ref="store" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="지역" prop="areaSeq">
              <el-select v-model="store.areaSeq" placeholder="지역">
                <el-option
                  v-for="item in $store.state.store.areas"
                  :key="item.areaSeq"
                  :label="item.areaName"
                  :value="item.areaSeq">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="지점명" prop="storeName">
              <el-input v-model="store.storeName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="호수" prop="storeNumber">
              <el-input type="number" v-model="store.storeNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="주소" prop="address">
              <el-input v-model="store.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="오픈일" prop="openDate">
              <el-date-picker
                v-model="store.openDate"
                type="date"
                placeholder="오픈일 선택"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="폐점일">
              <el-date-picker
                v-model="store.closeDate"
                type="date"
                placeholder="폐점일 선택"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="card-footer text-right">
          <el-button type="primary" v-if="type === 'new'" @click="submitForm('store')">등록</el-button>
          <el-button type="primary" v-if="type === 'edit'" @click="submitForm('store')">수정</el-button>
          <el-button v-if="type === 'new'" @click.prevent="resetForm('store')">리셋</el-button>
          <el-button @click.prevent="historyBack">취소</el-button>
        </div>
      </el-form>
    </card>
    <card class="w-100" v-if="type === 'edit'">
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="$store.state.store.storeFloors"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="층"
            width="150">
            <template slot-scope="props">
              {{ props.row.floorType === 'F' ? props.row.floor + props.row.floorType : props.row.floorType +
              props.row.floor }}
            </template>
          </el-table-column>
          <el-table-column
            label="도면">
            <template slot-scope="props">
              <img v-bind:src="'/api/common/store/' + props.row.storeSeq + '/store-floors/' + props.row.storeFloorSeq"
                   style="width: 300px"/>
            </template>
          </el-table-column>
          <el-table-column
            label="관리"
            width="250">
            <template slot-scope="props">
              <el-button type="danger" icon="el-icon-delete-solid" @click="handleFloorDelete(props.$index, props.row)">
                삭제
              </el-button>
              <el-button icon="el-icon-edit" @click="handleFloorEdit(props.$index, props.row)">수정
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-shopping-bag-1" v-on:click="showModal(true)">매장 층 추가</el-button>
        </div>
      </el-col>
    </card>
    <modal :show.sync="modals.isShow"
           footerClasses="justify-content-center"
           type="notice">
      <h5 slot="header" class="modal-title">도면 등록</h5>
      <template>
        <el-form class="form-horizontal" ref="storeFloorForm" label-width="120px">
          <el-form-item label="매체구분" prop="mediaType">
            <el-select v-model="formData.floorType">
              <el-option
                key="F"
                value="F"
                label="지상"></el-option>
              <el-option
                key="B"
                value="B"
                label="지하"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="층" prop="mediaType">
            <el-select v-model="formData.floor">
              <el-option v-for="f in 10"
                         :key="f"
                         :value="f"
                         :label="f"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="도면첨부" prop="upload">
            <el-upload
              class="upload-demo"
              ref="upload"
              action="/api/store/store-floors"
              :headers="header"
              :data="getFormParam"
              :limit="1"
              :on-success="handleSuccess"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">도면 선택</el-button>
            </el-upload>
          </el-form-item>
          <div class="pull-right mt-2">
            <el-button type="primary" icon="el-icon-check" @click="submitUpload">저장</el-button>
            <el-button icon="el-icon-close" v-on:click="showModal(false)">취소</el-button>
          </div>
        </el-form>
      </template>
    </modal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import {
    Select,
    Form,
    FormItem,
    Button,
    Option,
    Input,
    Row,
    Col,
    Upload,
    Table,
    TableColumn,
    DatePicker
  } from 'element-ui';
  import locale from 'element-ui/lib/locale/lang/ko';
  import StoreProxy from "../../../../proxies/StoreProxy";
  import StoreFloorProxy from "../../../../proxies/StoreFloorProxy";
  import {Modal} from 'src/components/UIComponents'

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(DatePicker, {locale})

  export default {
    name: "StoreRegistration",
    components: {
      elSelect: Select,
      elForm: Form,
      elFormItem: FormItem,
      elButton: Button,
      elOption: Option,
      elInput: Input,
      elRow: Row,
      elCol: Col,
      elUpload: Upload,
      modal: Modal,

    },
    computed: {
      getFormParam: function () {
        return {
          floor: this.formData.floor,
          floorType: this.formData.floorType,
          storeSeq: this.store.storeSeq,
        }
      }
    },
    created: function () {
      this.$store.dispatch('store/getAreaList');
      if (this.$route.params.storeSeq !== undefined) {
        this.type = "edit";
        this.store.storeSeq = this.$route.params.storeSeq;
        this.$store.dispatch('common/setMenuTitle', "점포수정");
        new StoreProxy()
          .find(this.store.storeSeq)
          .then((response) => {
            this.store = response.store;
            this.$store.dispatch('store/findAllStoreFloors', this.store.storeSeq);
          })
      } else {
        this.type = "new";
        this.$store.dispatch('common/setMenuTitle', "점포등록");
      }
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.type === "new") {
              if (confirm("등록하시겠습니까?")) {
                this.store.storeStatus = "OPEN";
                this.$store.dispatch("store/createStore", this.store);
              }
            } else {
              if (confirm("수정하시겠습니까?")) {
                this.store.regDate = null;
                this.store.openDate = this.formatDate(new Date(Date.parse(this.store.openDate)));
                if (this.store.closeDate !== undefined) {
                  this.store.closeDate = this.formatDate(new Date(Date.parse(this.store.closeDate)));
                }
                this.$store.dispatch("store/editStore", this.store);
              }
            }
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      historyBack() {
        history.back();
      },
      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;

        return [year, month, day].join('-');
      },
      handleFloorEdit(index, row) {
        Vue.router.push({name: 'StoreFloorEdit', params: {storeSeq: row.storeSeq, storeFloorSeq: row.storeFloorSeq}});
      },
      handleFloorDelete(index, row) {
        if(confirm("해당 층을 삭제하시면 광고도 같이 삭제됩니다. \n삭제하시겠습니까?")) {
          new StoreFloorProxy()
            .destroy(row.storeFloorSeq)
            .then((response) => {
              if (response.header.returnCode === "OK") {
                this.$store.dispatch('store/findAllStoreFloors', this.store.storeSeq);
              } else {
                alert(response.header.resultMessages);
              }
            })
        }
      },
      showModal(isShow) {
        this.$refs.upload.clearFiles();
        this.$refs['storeFloorForm'].resetFields();
        this.modals.isShow = isShow;
      },
      submitUpload() {
        if (this.$refs.upload.uploadFiles.length > 0) {
          this.$refs.upload.submit();
        } else {
          alert("도면을 선택하세요.");
        }
      },
      handleSuccess(response, files, fileList) {
        this.$refs.upload.clearFiles();
        this.formData.floor = '';
        this.formData.floorType = '';
        this.showModal(false);
        // 층 조회
        this.$store.dispatch('store/findAllStoreFloors', this.store.storeSeq);
      },
    },
    data() {
      return {
        modals: {
          isShow: false,
        },
        type: '',
        store: {
          storeSeq: null,
          areaSeq: null,
          storeName: null,
          storeNumber: '',
          address: '',
          openDate: '',
          closeDate: '',
          floor: '',
          storeStatus: '',
        },
        storeFloors: [],
        storeFloorSeq: '',
        rules: {
          areaSeq: [
            {required: true, message: '지역을 선택하세요.', trigger: 'change'}
          ],
          storeName: [
            {required: true, message: '지점명을 입력하세요.', trigger: 'blur'}
          ],
          storeNumber: [
            {required: true, message: '호수를 입력하세요.', trigger: 'blur'}
          ],
          address: [
            {required: true, message: '주소를 입력하세요.', trigger: 'blur'}
          ],
          openDate: [
            {required: true, message: '오픈일을 입력하세요.', trigger: 'blur'}
          ],
        },
        fileList: [],
        formData: {
          floorType: "F",
          floor: 1,
        },
        header: {
          Authorization: $cookies.get('id_token')
        },
      }
    },

  }
</script>

<style scoped>

</style>
